import { Typography } from "@mui/material";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { HeadingLevel, IconPosition, MaterialColors } from "@/core/types/types";
import { Box } from "@mui/system";
import { TextVariant } from "@/core/components/Field/Text";

const UnsubscribeAction = () => {
  return (
    <Box textAlign="center">
      <Box display="flex" justifyContent="center">
        <Box width="fit-content">
          <TextVariant
            text={t("action.unsubscribe.success.title")}
            variant={HeadingLevel.H3}
            iconName="CheckCircle"
            iconPosition={IconPosition.IconBefore}
            iconColor={MaterialColors.Primary}
          />
        </Box>
      </Box>
      <Box mt={2}>
        <Typography variant={HeadingLevel.Body2}>
          {t("action.unsubscribe.success.subtitle")}
        </Typography>
      </Box>
    </Box>
  );
};

export default UnsubscribeAction;
